import React from "react";

import {
  Text,
  BlockQuote,
  Quote,
  S,
  Appear,
  Slide,
  List,
  ListItem
} from "spectacle";
import { CustomHeading } from "../../custom-style";

export default () => {
  return (
    <Slide>
      <CustomHeading>Más información</CustomHeading>
      <List>
        <Appear>
          <div>
            <ListItem>
              <S type="bold">martinfowler.com</S> - El AMO y SEÑOR del Testing
              (para mí)
            </ListItem>
            <ListItem>
              <S type="bold">Test Driven Development: By Example</S> - Kent Beck
            </ListItem>
          </div>
        </Appear>
      </List>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/04-conclusions/01-more-info.js